import React, {useEffect, useRef, useState} from "react";
import {observer} from "mobx-react-lite";
import {FileUpload} from "primereact/fileupload";

import appStore from "../../../../storage/AppStore";
import clubStore from "../../../../storage/ClubStore";

import Input from "../../../../ui/Input";
import Phone from "../../../../ui/Phone";


const CompanyUserCommon = ({member}) => {

    const [
        preview,
        setPreview,
    ] = useState(null);

    const fileUploadRef =
        useRef(null);


    const phoneRequired =
        member.role_id !== "MMBR";


    const photoRequired =
        !member.id;


    const photoInvalid =
        Boolean(
            member.was_validated &&
            photoRequired &&
            !member.photo_upload
        );


    useEffect(() => {
        return () => {
            if (preview) {
                URL.revokeObjectURL(
                    preview
                );
            }
        };
    }, [preview]);


    const handlePhotoSelect = (
        event
    ) => {

        const file =
            event.files?.[0];


        if (!file) {
            return;
        }


        if (preview) {
            URL.revokeObjectURL(
                preview
            );
        }


        member.setProperty(
            "photo_upload",
            file
        );


        setPreview(
            URL.createObjectURL(
                file
            )
        );


        fileUploadRef.current?.clear();
    };


    return (
        <>

            {/* PHOTO */}

            <div className="col-12 flex flex-column align-items-center">

                <div className="mb-2">

                    <img
                        src={
                            preview ||
                            member.avatar
                        }

                        className={[
                            "img",
                            "img-thumbnail",
                            photoInvalid &&
                                "p-invalid",
                        ]
                            .filter(Boolean)
                            .join(" ")
                        }

                        width={150}

                        alt={
                            member.title ||
                            appStore.tr.photo ||
                            ""
                        }
                    />

                </div>


                <FileUpload
                    ref={fileUploadRef}

                    mode="basic"

                    name="input_photo[]"

                    accept="image/*"

                    chooseLabel={
                        appStore.tr.photo
                    }

                    onSelect={
                        handlePhotoSelect
                    }
                />


                {member.photo_upload && (
                    <small className="mt-2 text-500">
                        {
                            member.photo_upload.name
                        }
                    </small>
                )}


                {photoInvalid && (
                    <small className="p-error mt-2">
                        {
                            appStore.tr.photo_required ||
                            appStore.tr.please_check_data
                        }
                    </small>
                )}

            </div>


            {/* FIRST NAME */}

            <div className="col-12">

                <label
                    htmlFor="input_first_name"
                    className="block mb-1"
                >
                    {appStore.tr.first_name}
                </label>


                <Input
                    id="input_first_name"

                    store={member}

                    prop="first_name"

                    label={
                        appStore.tr.first_name
                    }

                    required
                />

            </div>


            {/* LAST NAME */}

            <div className="col-12">

                <label
                    htmlFor="input_last_name"
                    className="block mb-1"
                >
                    {appStore.tr.last_name}
                </label>


                <Input
                    id="input_last_name"

                    store={member}

                    prop="last_name"

                    label={
                        appStore.tr.last_name
                    }

                    required
                />

            </div>


            {/* TITLE */}

            <div className="col-12">

                <label
                    htmlFor="input_title"
                    className="block mb-1"
                >
                    {appStore.tr.title}
                </label>


                <Input
                    id="input_title"

                    store={member}

                    prop="title"

                    label={
                        appStore.tr.title
                    }

                    required
                />

            </div>


            {/* PHONE */}

            <div className="col-12">

                <label
                    htmlFor="input_phone_number"
                    className="block mb-1"
                >
                    {appStore.tr.phone_number}
                </label>


                <Phone
                    country={
                        clubStore.club
                            .country_id
                            ?.toLowerCase() ||
                        "kg"
                    }

                    store={member}

                    prop="phone_number"

                    valid="is_valid_phone_number"

                    required={
                        phoneRequired
                    }

                    inputProps={{
                        id:
                            "input_phone_number",
                    }}
                />

            </div>

        </>
    );
};


export default observer(
    CompanyUserCommon
);